import { useMemo } from 'react';
import { CollectionState, FiltersMap } from '@wix/bex-core';
import { TableColumn as TableColumnWSR } from '@wix/design-system/dist/types/Table';
import { ActionsCell } from './ActionsCell';
import { useRenderActionsCellColumn } from './useRenderActionsCellColumn';
import { useActionsCellColumnBase } from './useActionsCellColumnBase';

export interface UseActionsCellColumnParams<T, F extends FiltersMap> {
  actionsCellWidth?: string | number;
  actionsCellProps?: Partial<Omit<TableColumnWSR<T>, 'render' | 'style'>>;
  sticky?: boolean;
  actionsCell?: ActionsCell<T, F>;
  collection: CollectionState<T, F>;
}

export function useActionsCellColumn<T, F extends FiltersMap>(
  params: UseActionsCellColumnParams<T, F>,
) {
  const {
    collection,
    actionsCell,
    actionsCellProps,
    actionsCellWidth,
    sticky,
  } = params;

  const baseColumn = useActionsCellColumnBase({
    actionsCellProps,
    actionsCellWidth,
  });

  const render = useRenderActionsCellColumn({
    actionsCell,
    sticky,
    collection,
  });

  return useMemo(() => {
    if (render == null) {
      return null;
    }

    return {
      ...baseColumn,
      render,
    };
  }, [baseColumn, render]);
}
